import cx from 'classnames';
import React from 'react';

import styles from './styles.css';
import Box from '../Box';
import Button, { ButtonProps } from '../Button';

interface MenuItemProps extends ButtonProps {
  selected?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({ children, className, selected, ...rest }) => {
  return (
    <Box element="li" className={cx(className, styles['menu-item'], { [styles['menu-item--selected']]: selected })}>
      <Button {...rest} className={styles['button']}>
        {children}
      </Button>
    </Box>
  );
};

export default MenuItem;
